<template>
  <!-- _________________________ SMS CODE _________________________ -->
  <div id="forgot-password-div">

    <h1 class="page-title mt-5">
      {{ $t('verificationCodeTitle') }}
    </h1>
    <h2 class="page-subtitle mt-3">
      {{ $t('verificationCodeSubtitle1') }}<strong>{{ phoneNumber }}</strong>{{ $t('verificationCodeSubtitle2') }}
    </h2>

    <form @submit.stop.prevent="handleSmsSubmit" class="mt-4">

      <b-alert :show="ui.showError" variant="danger">
        {{ ui.showErrorMessage }}
      </b-alert>

      <b-form-group
        :label="$t('smsCredential')"
        label-for="code-input">
        <b-form-input
          id="code-input"
          v-model="form.code.value"
          required
          @keydown="hideMessages">
        </b-form-input>
      </b-form-group>

      <div class="mt-4">
        <b-button type="submit" class="btn-block" variant="primary">{{ $t('smsButtonText') }}</b-button>
      </div>

    </form>

    <div class="mt-4 text-right">
      <b-link v-on:click="showLoginView" class="link-main-color">{{ $t('smsBackToLoginText') }}</b-link>
    </div>
  </div>
</template>

<script>

import api from '../../../services/api'

export default {

  name: 'SmsCodeComponent',

  data () {
    return {
      username: '',
      password: '',
      phoneNumber: '',
      form: {
        code: {
          value: null
        }
      },
      ui: {
        showError: false,
        showErrorMessage: this.$i18n.t('internal.server.error')
      }
    }
  },

  emits: ['showLoginView'],

  methods: {

    async handleSmsSubmit () {
      let loginIn = false
      let formData = new FormData()
      formData.append('code', this.form.code.value.trim())
      formData.append('username', this.username)
      formData.append('password', this.password)

      await api({
        method: 'POST',
        url: `/authentication/checkSmsCode`,
        data: formData
      })
        .then(async (response) => {
          if (response.status === 200) {
            const data = {
              username: this.form.username.value.trim(),
              password: this.form.password.value
            }

            await this.LogIn(data)

            this.ui.showError = false
            this.goToHome()
          }
        })
        .catch()((error) => {
          this.code.value = null
          if (!error.response) {
            console.log("error", error)
          }
          if (error.response && error.response.status === 401) {
            this.ui.showErrorMessage = this.$i18n.t('Login.error')
            this.ui.showError = true
          }
          if (error.response && error.response.status === 403) {
            this.ui.showErrorMessage = this.$i18n.t(error.response.data.message)
            this.ui.showError = true
          }
        })
    },

    showLoginView () {
      this.$emit('showLoginView')
    },

    hideMessages () {
      this.hideError()
    },

    hideError () {
      this.ui.showError = false
      this.ui.showErrorMessage = null
      this.ui.showValidateAccountError = false
    },

    goToHome () {
      this.$router.push({
        name: 'Home'
      })
    }

  }

}

</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/auth/components/SmsCodeComponent.vue